import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Job from "./Job";

@Model()
class Placement extends ApplicationRecord {
  static jsonapiType = "placements";

  @Attr({ persist: false }) createdAt: string;

  @Attr() jobId: number;

  @Attr() status: string;

  @BelongsTo(Job) job: Job;
}
export default Placement;
